export * from './scales';
export * from './formatting';
export * from './tooltip';
export * from './colors';

// Export findClosestXValue function
export const findClosestXValue = (
  mouseX: number,
  xValues: (string | number)[],
  xScale: (value: string | number) => number
) => {
  // Find the closest x value to the mouse position
  let closestValue = xValues[0];
  let minDistance = Math.abs(xScale(closestValue) - mouseX);

  for (let i = 1; i < xValues.length; i++) {
    const distance = Math.abs(xScale(xValues[i]) - mouseX);
    if (distance < minDistance) {
      minDistance = distance;
      closestValue = xValues[i];
    }
  }

  return closestValue;
};
